"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const SimpleKeyValueColumn_1 = tslib_1.__importDefault(require("./SimpleKeyValueColumn"));
class KeyValueColumnLinkDialog {
    constructor(args) {
        this.args = args;
        const { header, keyValueColumnData, striped } = args;
        this.element = document.createElement("div");
        this.element.classList.add("key-value-column-link-dialog");
        this.simpleKeyValueColumn = new SimpleKeyValueColumn_1.default({
            data: keyValueColumnData,
            header: header,
            striped: striped
        });
        this.element.appendChild(this.simpleKeyValueColumn.element);
        this.simpleKeyValueColumn.setHeaderVisible(false);
    }
    render() {
        this.simpleKeyValueColumn = new SimpleKeyValueColumn_1.default({
            data: this.args.keyValueColumnData,
            header: this.args.header
        });
        this.simpleKeyValueColumn.setHeaderVisible(false);
    }
    setHeader(header) {
        this.simpleKeyValueColumn.setHeader(header);
    }
    setData(data) {
        this.simpleKeyValueColumn.setData(data);
    }
    close() {
        //
    }
}
tslib_1.__decorate([
    (0, fmko_ts_common_1.DialogAction)({ label: "Luk", close: true })
], KeyValueColumnLinkDialog.prototype, "close", null);
exports.default = KeyValueColumnLinkDialog;
//# sourceMappingURL=KeyValueColumnLinkDialog.js.map